import { useContext, useEffect, useRef, useState } from "react"

const default_pic = '/app/assets/image/profile.jpg'


export default function ChangeProfilePic({ setImage, topic }) {
    const ref = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        const el = ref.current
        if (!el) return

        const handler = (e: Event) => {
            const ev = e as CustomEvent<{ image_id: string, image_url: string }>
            console.log(ev)
            setImage({ ...ev.detail })
        };

        el.addEventListener("image-id-change", handler);

        return () => el.removeEventListener("image-id-change", handler)
    }, [setImage]);

    return <div
        className="flex items-center gap-2 px-4 cursor-pointer"
        data-button-action="general-profile-upload"
        ref={ref}
    >
        <img className="rounded-full size-18 object-contain aspect-square"
            src={topic?.avatar_url || default_pic}
        />
        <span className="text-xs">تصویر</span>
    </div>
}